import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { MarketShopInventoryItem } from '@/models'
import { resetQueries } from '@/utils/api'

import { GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY } from './get-market-shop-inventory'

export type UpdateMarketShopProductRequest = {
  id: number
  data: {
    buildingId: number
    categoryId?: number | null
    description: string
    image: string | null
    price: number
    quantity: number
    summary: string
    tags: {
      tagId: number
      discount?: number
    }[]
    unlimited: boolean
    tax: number
  }
}

export const updateMarketShopProduct = async (data: UpdateMarketShopProductRequest) => {
  const response = await authAPI.put<MarketShopInventoryItem>(
    `/market-shop/product/${data.id}`,
    data.data,
  )
  return response.data
}

export const useUpdateMarketShopProduct = () => {
  return useMutation({
    mutationFn: updateMarketShopProduct,
    onSuccess: () => {
      resetQueries([GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY])
    },
  })
}
